import React, { useState } from "react";
import { Form, Card, Row, Col } from "react-bootstrap";

const HydrationCalculator = () => {
  const [flourWeight, setFlourWeight] = useState("");
  const [waterWeight, setWaterWeight] = useState("");

  const hydrationPercentage =
    flourWeight && waterWeight
      ? ((waterWeight / flourWeight) * 100).toFixed(1)
      : null;

  return (
    <div>
      <h1 className="mb-4">Hydration Calculator</h1>
      <Card className="mb-4">
        <Card.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Flour Weight (g)</Form.Label>
                  <Form.Control
                    type="number"
                    value={flourWeight}
                    onChange={(e) => setFlourWeight(Number(e.target.value))}
                    min="0"
                    step="1"
                    placeholder="Enter flour weight"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Water Weight (g)</Form.Label>
                  <Form.Control
                    type="number"
                    value={waterWeight}
                    onChange={(e) => setWaterWeight(Number(e.target.value))}
                    min="0"
                    step="1"
                    placeholder="Enter water weight"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>

          {hydrationPercentage && (
            <div className="text-center mt-4">
              <h3>Hydration Percentage</h3>
              <div className="display-4 mb-3">{hydrationPercentage}%</div>
              <p className="text-muted">
                {hydrationPercentage < 65
                  ? "Low hydration - will result in a denser crumb"
                  : hydrationPercentage > 80
                  ? "High hydration - will result in an open, airy crumb"
                  : "Medium hydration - balanced crumb structure"}
              </p>
            </div>
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <h4>About Hydration Percentage</h4>
          <p>
            The hydration percentage in bread baking is calculated using the
            formula:
          </p>
          <div className="text-center my-3">
            <code>Hydration (%) = (Water Weight / Flour Weight) × 100</code>
          </div>
          <p>
            This percentage determines how wet or dry your dough will be, which
            affects the final texture:
          </p>
          <ul>
            <li>
              <strong>60-65%:</strong> Lower hydration, easier to handle, denser
              crumb
            </li>
            <li>
              <strong>65-80%:</strong> Medium hydration, good for most breads
            </li>
            <li>
              <strong>80%+:</strong> High hydration, harder to handle, more open
              crumb
            </li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
};

export default HydrationCalculator;
